<template>
  <div class="flex float-left vertical-center">
    <div class="flex vertical-center center-horizontal" v-if="column === 'Status' && status !== '' && status !== null">
      <vs-chip class="line-0" v-bind:color="getColorStatusProvision(status)">
        {{ status }}
      </vs-chip>
    </div>
    <vs-button
      size="small"
      icon-pack="feather"
      icon="icon-settings"
      @click="configureRecord"
      v-if="isConfigure"
      color="dark"
      class="mr-2 padding-none"
    > Configure</vs-button>
      <vs-button
        size="small"
        icon-pack="feather"
        icon="icon-list"
        @click="detailRecord"
        color="primary"
        v-if="isDetail"
        class="mr-2 padding-none"
      >Detail</vs-button>
      <vs-button
              size="small"
              icon-pack="feather"
              icon="icon-x-circle"
              @click="cancelRecord"
              color="warning"
              v-if="isCancel && status === 'pending' "
              class="mr-2 padding-none"
      >Cancel</vs-button>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "ActionTableAgGridComponent",
  data() {
    return {
      isConfigure: false,
      isDetail: false,
      isCancel:false,
      status:""
    };
  },
  methods: {
    getColorStatusProvision(status){
      if (status === "pending") return "warning"
      if (status === "cancel") return "danger"
      if(status === "progress") return "primary"
      return "success"
    },
    detailRecord() {
        this.$root.$emit(
                "detail-from-ActionTableAgGridComponent",
                this.params.value
        );

    },
    configureRecord() {
      this.$root.$emit(
        "configure-from-ActionTableAgGridComponent",
        this.params.value
      );
    },
    cancelRecord() {
      this.$root.$emit(
              "cancel-from-ActionTableAgGridComponent",
              this.params.value
      );
    }
  },
  created() {
    this.isConfigure = this.params.isConfigure;
    this.isDetail = this.params.isDetail;
    this.isCancel = this.params.isCancel;
    this.status = this.params.data.status
    this.column = this.params.colDef.headerName
  }
});
</script>

<style scoped>
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.line-0 {
  line-height: 0;
}
.center-horizontal{
  margin-left: -20% !important;
}
.padding-none{
  padding: 5px !important;
}
</style>